import { Control, Controller, FieldValues, FieldPath } from 'react-hook-form';
import { cn } from '@/lib/utils.ts';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import PrimitiveCheckboxGroup from '@/components/form/_primitives/PrimitiveCheckboxGroup.tsx';
import Option from '@/components/form/types/Option.ts';

const CheckboxGroupInput = <T extends FieldValues>({
  fieldPath,
  control,
  options = [],
  label,
  required = false,
  error,
  className,
  disabled = false,
  onChange: onChangeProp,
}: {
  fieldPath: FieldPath<T>;
  control: Control<T>;
  options?: Option[];
  label?: string;
  required?: boolean;
  error?: string;
  className?: string;
  disabled?: boolean;
  onChange?: (values: string[]) => void;
}) => {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <InputLabel label={label} required={required} disabled={disabled} />
      )}
      <Controller
        control={control}
        name={fieldPath}
        render={({ field }) => (
          <PrimitiveCheckboxGroup
            name={fieldPath}
            options={options}
            disabled={disabled}
            value={field.value}
            onChange={(values) => {
              field.onChange(values);
              onChangeProp?.(values);
            }}
          />
        )}
      />
      {error && <InputError error={error} />}
    </div>
  );
};

export default CheckboxGroupInput;
